import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  const logoSlider = document.getElementById("logoSlider");

  if (logoSlider) {
    const testimonialSlider = new Splide(logoSlider, {
      type: "carousel",
      perPage: 2,
      perMove: 1,
      //focus: "center",
      //   rewind: true,
      arrows: true,
      pagination: true,
      mediaQuery: "min",
      breakpoints: {
        768: {
          perPage: 6,
          pagination: false,
          arrows: true,
        },
      },
    }).mount();
  }
});
